import {
  Stack,
} from '@mui/material';
import { observer } from 'mobx-react';
import React from 'react';
import {
  Control, Controller, useFieldArray, UseFormSetValue,
} from 'react-hook-form';
import { OTP_REGEX } from './constants';
import OtpDigitField from './OtpDigitField';
import { OtpFormValues } from './types';

type Props = {
  control: Control<OtpFormValues>,
  setValue: UseFormSetValue<OtpFormValues>,
  fontSize: string | number,
  height: number,
}

const OtpFields: React.FC<Props> = ({
  control, setValue, fontSize, height,
}) => {
  const { fields } = useFieldArray({
    control,
    name: 'otpDigits',
  });
  const digitRefs = React.useRef<Array<React.RefObject<HTMLInputElement | null>>>(Array.from({ length: 6 }, () => React.createRef<HTMLInputElement>()));

  const onOtpPaste = React.useCallback(
    (e: React.ClipboardEvent<HTMLDivElement>) => {
      const otp = e.clipboardData.getData('text');
      if (OTP_REGEX.test(otp)) {
        otp.split('').forEach((digit, index) => {
          if (fields[index]) {
            setValue(`otpDigits.${index}.value`, digit);
          }
        });
      } else {
        e.preventDefault();
      }
    },
    [setValue, fields],
  );

  return (
    <Stack spacing={0.5} direction="row" height={height}>
      {fields.map((field, index) => (
        <Controller
          key={field.id}
          name={`otpDigits.${index}.value`}
          control={control}
          rules={{
            required: true,
          }}
          render={({
            fieldState: { error },
            field: {
              value,
              onChange,
            },
          }) => (
            <OtpDigitField
              value={value}
              error={!!error}
              onChange={onChange}
              onPaste={onOtpPaste}
              inputRef={digitRefs.current[index]}
              nextRef={index < fields.length - 1 ? digitRefs.current[index + 1] : undefined}
              previousRef={index > 0 ? digitRefs.current[index - 1] : undefined}
              fontSize={fontSize}
            />
          )}
        />
      ))}
    </Stack>
  );
};

export default observer(OtpFields);
